import React, { Component} from 'react';
import TreeView from 'react-treeview';

import 'react-treeview/react-treeview.css';
import './side.css';

const dataSource = {
    pageIndex : 0,
    level : 0,
    str: '목차',
    collapsed: false,
    tocItems: []
};

export default class SideBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tocItems: this.props.tocInfo,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            tocItems: nextProps.tocInfo,
        })
    }


    findParent(parent , item) {
        var findItem;
        if (item.level === 1) {
            return parent;
        } else if (parent.level === (item.level -1) && (parent.pageIndex === item.pageIndex) ) {
            return parent;
        } else {
            for(var i in parent.tocItems) {
              if (parent.tocItems.hasOwnProperty(i)){
                findItem = this.findParent(parent.tocItems[i],item);
                if (findItem !== undefined) {
                    return findItem;
                }
              }
            }
        }
        return findItem;
    }

    genTocItem(tocItems) {
    	if (dataSource.tocItems.length === 0 ){
    		tocItems.forEach((node, i) => {
            let p = this.findParent(dataSource,node);
                if (p !== undefined) {
                    let newitem  = Object.assign({collapsed: false,tocItems:[]}, node);
                    p.tocItems.push(newitem);
                }
        })
    	}        
    }

    render_treeview(treeItem) {
        var roots = treeItem.tocItems.map((node,i) => {
            if (node.tocItems.length > 0) {
            		const label = <span className="node" onClick={this.handleClick.bind(this, node.pageIndex)}>{node.str}</span>
                return (<TreeView  key={ node.index } nodeLabel={ label } defaultCollapsed={false}> { this.render_treeview(node) } </TreeView>);
       			} else {
       					const space = <span>&nbsp;&nbsp;&nbsp;&nbsp;</span> 
       					const label = <span className="node" onClick={this.handleClick.bind(this, node.pageIndex)}>{node.str} </span>
       				  return <div className="info">{space}{label}</div>
       			}
        });

        return (roots)
    }

    handleClick(i) {
        console.log("handleClick :" + i);

        if (this.props.movePageIndex  !== undefined) {
            this.props.toggleSideView()
            this.props.movePageIndex(i-1)
        }
    }

    render() {
        this.genTocItem(this.state.tocItems);
        return (
            <div className="SideBar RightBorder no-print">
                <div className="SideContent">
                    {
                        <TreeView key={ dataSource.index } nodeLabel={  dataSource.str } defaultCollapsed={false}> { this.render_treeview(dataSource) } </TreeView>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/side.js